
















import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class Home extends Vue {
  @Prop({ default: '20' }) readonly width?: string;
  @Prop({ default: '20' }) readonly height?: string;
  @Prop({ default: '#3E24D6' }) readonly fill?: string;
}
